import { isInIXPControlTreatment, isInIXPExperimentalTreatment } from 'store/ixp/selector';
import { IXP } from 'types/IXP';

type PlaidExperimentResult = {
  isPlaidExperimentEnabled: boolean;
  isInPlaidExperimentAnyGroup: boolean;
};

/**
 * Check if Plaid Bank Login experiment is enabled for the current user
 *
 * This function only checks if the user is in the IXP experiment treatment group.
 * All other eligibility criteria are handled by IXP Target Audience Rules in the IXP dashboard:
 *
 * IXP Target Audience Rules (6 rules):
 * 1. region === "US"                           - US locale only
 * 2. achEnabled === true                       - ACH payment method required
 * 3. creditCardPaymentEnabled === false        - ACH-only invoices (no CC)
 * 4. isPayPalEnabled === false                 - ACH-only invoices (no PayPal)
 * 5. saleType === "INVOICE"                    - Invoice type only (not payment requests)
 * 6. isMaipInvoice === false                   - Exclude MAIP invoices (ACH convenience fee)
 *
 * The IXP context (built in server/helpers/invoiceDiscovery.ts::buildIXPContext) automatically includes
 * all these fields in the contextMap for server-side eligibility evaluation.
 *
 * @param ixp - IXP experiment state from Redux store
 * @returns Object with isPlaidExperimentEnabled boolean
 */
export const checkPlaidExperimentEnabled = (ixp: IXP): PlaidExperimentResult => {
  const experimentKey = 'PlaidBankLogin';

  // Check if experiment is running and user is in treatment
  // IXP Target Audience Rules handle all eligibility criteria on the server side
  const isInTreatment = isInIXPExperimentalTreatment({ ixp, featureFlags: {} }, experimentKey);
  const isInControl = isInIXPControlTreatment({ ixp, featureFlags: {} }, experimentKey);

  return {
    isPlaidExperimentEnabled: isInTreatment,
    isInPlaidExperimentAnyGroup: isInTreatment || isInControl,
  };
};
